const getShortenLabel = (label, maxSymbols) =>
  `${label?.length > maxSymbols ? `${label?.substr(0, maxSymbols)}...` : `${label}`}`;

export default getShortenLabel;
